import VoipReportPage from "pages/VoipReport/VoipReportPage";

const VoipReportRoute = [
  {
    path: '/voip-report',
    exact: true,
    name: 'Báo cáo VoIP Grandstream',
    function: 'SYS_VOIP_REPORT_VIEW',
    component: VoipReportPage,
  },
];

export default VoipReportRoute;
